export  default {

    //заполнить данные по web пользователям
    loadNewRequests(state, data) {
        state.newRequests = data;
    },
    loadArchiveRequests(state, data) {
        state.archiveRequests = data;
    },

    loadActiveRequests(state, data) {
        state.activeRequests = data;
    },

    //обновить заявку
    loadById(state, data) {
        var ind = state.newRequests.findIndex(x => x.id == data.id);
        if (ind != -1 && ind != undefined)
            state.newRequests.splice(ind, 1, data);
        else
            state.newRequests.push(data);
    },

    // отказаться от заявки
    declineRequest(state, id) {
        var ind = state.newRequests.findIndex(x => x.id == id);
        if (ind != -1 && ind != undefined)
            state.newRequests.splice(ind, 1);
    },

    // принять заявку
    acceptRequest(state, data) {
        var ind = state.newRequests.findIndex(x => x.id == data.requestId);
        if (ind != -1 && ind != undefined)
            state.newRequests.splice(ind, 1);
    },

    markRead(state, id){
        let ind= state.newRequests.findIndex(x=>x.id==id)
        if(ind!=-1){
            state.newRequests[ind].isRead=true
        }
    },

    archiveRequest(state,id){
        let ind= state.newRequests.findIndex(x=>x.id==id)
        if(ind!=-1){
            state.newRequests.splice(ind,1)
        }
    }
}
